module.exports = fox._r("images/press/icon-social-yt.png", __webpack_public_path__ + "_/common/images/press/icon-social-yt.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-social-yt.png
// module id = 387
// module chunks = 2